import {Component,ElementRef,Input,OnInit,Output,ViewChild,EventEmitter} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MultiSelectorDetails } from 'src/app/model/multi-selector-details';
import { messages } from 'src/app/resources/messages';
import { CatalogService } from 'src/app/services/catalog.service';

@Component({
  selector: 'transaction-status-dropdown',
  templateUrl: './transaction-status-dropdown.component.html',
  styleUrls: ['./transaction-status-dropdown.component.scss']
})
export class TransactionStatusDropdownComponent implements OnInit {
  @Input() isOptional: boolean = true;
  @Input() displayLabel!: string;
  @Input() allowMultiSelect: boolean = true;
  @Input() selectorControlName!: AbstractControl<string>;
  @Input() submitted!: string;
  @Input() ariaText: string ='Transaction status drop down';
  @Output() selectedValues = new EventEmitter<string[]>();
  @Input() defaultStatus: MultiSelectorDetails = { id: '', description: [] };
  @Input() transactionPredefinedStatusList:any = [];
  @ViewChild('transactionStatusReference') trasactionStatusRef!: ElementRef;

  public msg = messages;
  public transactionStatusList: MultiSelectorDetails[] = [];
  public maxSelectionCount: number | undefined;
  public componentId!: string;
  public selectedValue:any;
  constructor(private catalogService: CatalogService) { }

  ngOnInit(): void {
    this.setId();
    this.getTransactionStatusData();
    this.setMaxlimit();
  }

  private getTransactionStatusData() {
    this.catalogService.getTransactionStatus().subscribe(response => {
      if (this.transactionPredefinedStatusList?.length >= 1) {
        this.transactionStatusList = response.data.filter(x => this.transactionPredefinedStatusList?.includes(x.statusId))
          .map(x => <MultiSelectorDetails><unknown>{
            id: x.statusId,
            description: [x.statusDesc]
          })
      } else {
        this.transactionStatusList = response.data.map(x => <MultiSelectorDetails><unknown>{
          id: x.statusId,
          description: [x.statusDesc]
        });
      }
      setTimeout(() => { this.selectedValue = this.defaultStatus; }, 500);
    });
  }

  public setSelectedTransactionStatus($event: any) {
    let trasactionStatus: string[] = $event.detail?.selectedItemArray.map(
      (x: MultiSelectorDetails) => x.id
    );
    this.selectedValues.emit(trasactionStatus);
    if (this.maxSelectionCount === 1) {
      this.trasactionStatusRef?.nativeElement.closeSelectionPanel();
    }
  }

  private setMaxlimit() {
    if (this.allowMultiSelect) {
      this.maxSelectionCount = undefined;
    } else {
      this.maxSelectionCount = 1;
    }
  }

  private setId() {
    if (!this.displayLabel) {
      this.componentId = 'Transaction status';
    } else {
      this.componentId = this.displayLabel.replace(' ', '-');
    }
  }

  public reset() {
    if(!this.defaultStatus?.id || this.defaultStatus?.id !== this.selectedValue?.id){
      this.trasactionStatusRef?.nativeElement.resetSelectMenu();
    }
    if(this.defaultStatus?.id){
      this.selectedValue = this.defaultStatus;
    }
  }

  
  public getAllTransactionStatus(): string[] {
    let allTransactionStatus = this.transactionStatusList.map(
      (x: MultiSelectorDetails) => x.id!);
    return allTransactionStatus;
  }
}
